module.exports = __webpack_public_path__ + "resources/img/img_awesome_secure_trust4_en.2c281370ed863c9ed9bedd2a7d3bfd9e.png";